<template>
    <form @submit.prevent="handleSubmit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ item.id ? 'Update' : 'Create' }} Dictionary Entry</p>
            </header>

            <section class="modal-card-body">
                <o-field label="Name" :type="fieldType('name')" :message="getError('name')">
                    <o-input placeholder="Name" v-model="copy.name"/>
                </o-field>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import HandlesForm from '../../mixins/HandlesForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        mixins: [HandlesForm],

        methods: {
            ...mapActions(['createOrUpdateDictionaryEntry']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.createOrUpdateDictionaryEntry)

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Dictionary entry was successfull ' + (this.item.id ? 'updated' : 'created'))
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        },

        computed: {
            ...mapGetters({
                determinationStatuses: 'determinationStatuses',
                applicants: 'contacts'
            })
        }
    }
</script>
